var _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgCistecinline = function SvgCistecinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 141,
    height: 24,
    fill: "none",
    viewBox: "0 0 141 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M43.643 23.683c-6.948 0-9.819-5.223-9.819-11.292 0-5.751 2.74-12.01 9.6-12.01 3.024 0 5.764 1.226 7.364 3.806l-2.39 1.374c-.92-1.628-2.673-2.622-4.602-2.622H43.6c-5.128 0-6.597 5.266-6.597 9.304 0 4.314 1.688 8.903 6.904 8.903h.044c1.84 0 3.572-.846 4.646-2.284l2.28 1.459c-1.557 2.41-4.384 3.362-7.233 3.362M56.223 23.239V.909h2.98v22.33h-2.98M73.362 23.852h-.176c-2.761 0-5.457-.952-7.561-2.686l1.841-1.987c1.534 1.417 3.572 2.199 5.676 2.22 2.324 0 4.91-.867 4.91-3.531 0-2.897-3.354-3.743-6.51-5.033-2.849-1.163-5.544-2.643-5.544-6.132 0-4.06 3.616-6.407 7.56-6.407h.198c2.28 0 4.515.677 6.4 1.924l-1.644 2.157c-1.425-1.057-3.178-1.628-4.975-1.67-2.214 0-4.45 1.162-4.45 3.573 0 2.537 2.5 3.531 5.217 4.525 3.244 1.248 6.772 2.474 6.772 6.64 0 4.144-3.704 6.407-7.714 6.407M133.742 23.683c-6.948 0-9.797-5.223-9.797-11.292 0-5.751 2.718-12.01 9.578-12.01 3.046 0 5.764 1.226 7.364 3.806l-2.367 1.374c-.943-1.628-2.696-2.622-4.603-2.622h-.219c-5.128 0-6.597 5.266-6.597 9.304 0 4.314 1.688 8.903 6.926 8.903h.022c1.841 0 3.572-.846 4.646-2.284l2.28 1.459c-1.535 2.41-4.362 3.362-7.233 3.362M99.462.888H85.523v2.58h5.567v19.77h2.98V3.468h5.392V.887ZM119.76 3.467V.887h-14.772v22.33h14.772V20.66h-11.769V13.3h8.591v-2.559h-8.591V3.467h11.769Z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#cistec_inline_svg__a)",
    fillRule: "evenodd",
    d: "M18.415 7.74v8.5h2.017c2.433 0 4.405-1.903 4.405-4.25 0-2.348-1.973-4.25-4.405-4.25h-2.017M7.961 4.313v3.34H4.542C2.044 7.655.027 9.6.027 11.99c0 2.411 2.017 4.356 4.515 4.356h3.42v3.32c0 2.39 1.994 4.335 4.47 4.335 2.477 0 4.493-1.945 4.493-4.335V4.314C16.925 1.945 14.91 0 12.432 0c-2.476 0-4.47 1.945-4.47 4.314Z",
    clipRule: "evenodd"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "cistec_inline_svg__a",
    x1: 3.742,
    x2: 20.51,
    y1: 3.606,
    y2: 20.985,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7DD27D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#5ECA8F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#3BC1A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.761,
    stopColor: "#26BBAF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#1EB9B4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1EB9B4"
  })))));
};
export default SvgCistecinline;